export default __webpack_public_path__ + "static/fire-emblem-tactics-691bdb941c592c1c7871174ba83f9257.png";